<template>
  <div>
    <div>
      loading...
    </div>
  </div>
</template>

<script>
import services from '@/services'

export default {
  name: 'LinkedinAuth',
  mounted() {
    // Preparação de objetos que levarão ao backend informações de login na socialmedia

    if (this.$route.query.error) {
      this.$router.push({ name: 'login' })
    } else {
      this.$store
        .dispatch('auth/loginExternalLinkedin', this.$route.query.code)
        .then(resp => {
          // Caso possua cadastro
          if (resp.success) {
            // Verifica se o utilizador possui mais de uma organization
            services
              .getUserOrganizations(this.$store.state.auth.user.id, null, 1, 10)
              .then(res => {
                let list = res.data.data.items

                if (Array.isArray(list)) {
                  // Caso possua apenas uma organização, redireciona para home
                  if (list.length === 1) {
                    this.$store.dispatch('auth/selectOrganization', { value: list[0].organizationId }).then(res => {
                      this.$router.push({ name: 'home' })
                    })

                    // Caso possua mais de uma organização, redireciona para ecrã de seleção de organização
                  } else {
                    this.$router.push({ name: 'OrganizationSelection' })
                  }
                }
              })
              .catch(err => {})
          } else {
            this.$router.push({
              name: 'NewRegister-External',
              params: {
                name: encodeURI(resp.data.name),
                email: encodeURI(resp.data.email),
              },
            })
          }
        })
        .catch(err => {
          switch (err.errorCode) {
            case 6031:
              if (Array.isArray(err.errorParameters)) {
                if (err.errorParameters.length > 0) {
                  try {
                    let errorData = JSON.parse(err.errorParameters[0])
                    this.$store.commit('auth/UPDATE_REGISTER_STEP', errorData)
                    this.$router.push({ name: 'BusinessProfile' })
                    return
                  } catch (error) {
                    // TODO tratar
                  }
                } else {
                  this.$router.push({ name: 'Login' })
                }
              } else {
                this.$router.push({ name: 'Login' })
              }
              break
            case 10033:
              if (Array.isArray(err.errorParameters)) {
                if (err.errorParameters.length > 0) {
                  try {
                    let errorData = JSON.parse(err.errorParameters[0])
                    this.$store.commit('auth/UPDATE_REGISTER_STEP', errorData)
                    this.$router.push({ name: 'ConfirmRegister' })
                    return
                  } catch (error) {
                    // TODO tratar
                  }
                } else {
                  this.$router.push({ name: 'Login' })
                }
              } else {
                this.$router.push({ name: 'Login' })
              }
              break
            default:
              this.$router.push({ name: 'Login' })
              break
          }
          this.$router.push({ name: 'Login' })
        })
    }
  },
}
</script>

<style scoped></style>
